import { Component, Input, OnInit, ViewChild, OnChanges, ElementRef, AfterViewInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AlertController, GestureController, IonContent, Platform, PopoverController, ToastController } from '@ionic/angular';

import { ChatService } from 'src/app/services/chat.service';
import { UserService } from 'src/app/services/user.service';
//import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { Camera, CameraResultType } from '@capacitor/camera';
import { StorageService } from 'src/app/services/storage.service';
import { finalize } from 'rxjs/operators';
import { Upload } from 'src/app/interfaces/upload';
import { ModalController } from '@ionic/angular';
import { ViewerModalComponent } from 'ngx-ionic-image-viewer';
import { Media, MediaObject } from '@ionic-native/media/ngx';
import { File as NativeFile, FileEntry } from '@ionic-native/file/ngx';
import { BtnsPopoverComponent } from '../btns-popover/btns-popover.component';
import { SocketService } from 'src/app/services/socket.service';

//declare let MediaRecorder: any;

@Component({
  selector: 'app-messenger',
  templateUrl: './messenger.component.html',
  styleUrls: ['./messenger.component.scss'],
})
export class MessengerComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  @ViewChild('docFile') docFile: ElementRef<HTMLInputElement>;
  @ViewChild('galleryFile') galleryFile: ElementRef<HTMLInputElement>;
  @ViewChild('camPicFile') camPicFile: ElementRef<HTMLInputElement>;
  @ViewChild('camVideoFile') camVideoFile: ElementRef<HTMLInputElement>;
  @ViewChild('audioFab', {read: ElementRef}) audioFab: ElementRef;
  @ViewChild('audioRecordBox', {read: ElementRef}) audioRecordBox: ElementRef;
  @ViewChild('cancelSlider', {read: ElementRef}) cancelSlider: ElementRef;
  @ViewChild('audioTimer', {read: ElementRef}) audioTimer: ElementRef;

  @Input() chatData: any;
  @Input() isAgentSession: boolean;

  @Output() msgAction = new EventEmitter<string>();

  loading: HTMLIonLoadingElement;
  messageList: any[];
  uploads: Upload[] = [];
  scollElement: HTMLElement;
  wheelEventTimeout: any;

  messageListLength = 20;
  prevMessagesAmount = 20;
  lastPrevQueryAmount = 20;
  loadingPrevMessages = false;

  newMsg: any;
  userID: number;
  iamCustomer: boolean;

  markAsReadTimeout: any;
  attachmentFabsVisible = false;

  selectedMessages = [];
  selectionTimer: any;
  longPressTimer: any;
  isDeletingMessages = false;

  audioRecording = {
    started: false,
    recorder: null,
    wasCanceled: false,
    file: {
      entry: null,
      media: null,
      name: '',
      path: '',
      pathAbs: ''
    },
    timer: {
      parsed: '00:00',
      seconds: 0,
      interval: null
    }
  };

  colorPerUser = {};

  socketEventListeners: any = {};

  constructor(
    private chatService: ChatService,
    private userService: UserService,
    private socketService: SocketService,
    private storageService: StorageService,
    private alertController: AlertController,
    private popoverController: PopoverController,
    private toastController: ToastController,
    private platform: Platform,
    private modalController: ModalController,
    private gestureCtrl: GestureController,
    private media: Media,
    private nativeFile: NativeFile
    ) { }

  ngOnInit() {
    this.clearNewMsg();
  }

  ngOnChanges(changes) {
    console.log('NG ON CHANGES', changes);


    if (changes.chatData && changes.chatData.currentValue !== null && changes.chatData.currentValue !== undefined) {
      if (changes.chatData.previousValue === undefined) {
        this.userID = this.userService.currentUser.id;
        this.iamCustomer = this.userService.currentUser.is_customer;
      }

      if (changes.chatData.previousValue === undefined || changes.chatData.previousValue.id !== this.chatData.id) {
        this.getChatMessages();

        if(this.chatData.is_group) {
          this.setUsersColor();
        }

        this.clearNewMsg();
      }
    }
    else if (changes.chatData && changes.chatData.currentValue === undefined) {
      this.endSocketSubscriptions();
    }
  }

  ngAfterViewInit() {

    this.setupAudioGesture();
    window.oncontextmenu = () => false;
    //this.markAsRead('ngAfterViewInit'); ?? 

  }

  ngOnDestroy(): void {
    this.endSocketSubscriptions();
  }

  endSocketSubscriptions() {
    for (const [evt, listener] of Object.entries(this.socketEventListeners)) {
      console.log('unsusc from', evt);
      this.socketService.unsubscribe(evt, listener);
    }
    this.socketEventListeners = {};
  }

  setUsersColor() {
    let c = 1;
    for (const u of this.chatData.users) {
      this.colorPerUser[u.user_id] = 'color-' + c;
      c = (c === 20 ? 1 : (c + 1));
    }
  }

  async checkScroll(ev, from, index){

    if (index < this.messageListLength) {
      console.log('srolledFrom: '+from);
      this.content.scrollToBottom(300);
    }
  }

  clearNewMsg() {
    this.newMsg = {
      type: 'text',
      text: ''
    };
  }

  checkKeyCode(keyCode) {
    if (keyCode === 13) {
      this.sendMessage();
      return false;
    }

    return true;
  }

  sendMessage() {
    if (this.newMsg.type === 'text') {
      if (this.newMsg.text.trim() === '') {
        return false;
      }
    }

    this.chatService.createMessage(this.chatData.id, this.newMsg.type, this.newMsg.text).subscribe(result => {
      if (!result.error) {
        console.log('Message sent', result);
        this.clearNewMsg();
      }      
    });    
  }

  async getChatMessages() {

    if (this.chatData.id) {
      this.messageList = [];

      this.chatService.getChatMessages(this.chatData.id, this.messageListLength, 0).subscribe((res) => {
        if (!res.error) {
          this.initSocketSubscriptions();
          console.log('Initial messages', res);

          for(const msg of res.messages) {
            this.handleMessageChange(msg);
          }
        }

        setTimeout(()=>{
          this.checkScroll(null, 'messages+1500', 0);
        },500);

        this.subscribeToScrollTop();

      });
    }
    else {
      setTimeout(()=>{
        this.getChatMessages();
      },1000);
    }
  }

  async getPrevMessages() {
    // if last time it brings less messages then there is no more of those.
    if (!this.loadingPrevMessages && this.lastPrevQueryAmount >= this.prevMessagesAmount) {
      this.loadingPrevMessages = true;
      console.log('entra getPrevMessages', this.lastPrevQueryAmount, this.prevMessagesAmount);

      this.chatService.getChatMessages(this.chatData.id, this.prevMessagesAmount, this.messageList.length).subscribe(
        (result) => {
          if (!result.error) {
            console.log('Prev messages', result.messages);

            this.lastPrevQueryAmount = result.messages.length;

            for(const msg of result.messages) {
              this.handleMessageChange(msg);
            }
          }

          this.loadingPrevMessages = false;
        });
    }
  }

  handleMessageChange(msg) {
    const existingIdx = this.messageList.findIndex(m => m.id === msg.id);

    if (existingIdx < 0) {
      //this.messageList.push(msg);
      this.insertSorted(this.messageList, msg, (a, b) => {
        return (a.created_at > b.created_at ? -1 : 1);
      });
    }
    else {
      this.messageList[existingIdx] = msg;
    }
  }

  insertSorted(arr, item, comparator?) {
    if (comparator == null) {
        // emulate the default Array.sort() comparator
        comparator = (a, b) => {
          if (typeof a !== 'string') { a = String(a); };
          if (typeof b !== 'string') { b = String(b); };
          return (a > b ? 1 : (a < b ? -1 : 0));
        };
    }

    // get the index we need to insert the item at
    let min = 0;
    let max = arr.length;
    let index = Math.floor((min + max) / 2);
    while (max > min) {
        if (comparator(item, arr[index]) < 0) {
            max = index;
        } else {
            min = index + 1;
        }
        index = Math.floor((min + max) / 2);
    }

    // insert the item
    arr.splice(index, 0, item);
  }

  initSocketSubscriptions() {

    this.endSocketSubscriptions();
    
    this.socketEventListeners[`userNewMessage:${this.chatData.id}`] = (data) => {
      console.log('SOCKET MESSAGES -> userNewMessage', data);
      this.handleMessageChange(data.msg);
      setTimeout(()=>{
        this.checkScroll(null, 'newMsgSocket', 0);
      },500);
      
      //this.changeDetector.detectChanges();
      
    }

    this.socketEventListeners[`deletedMessages:${this.chatData.id}`] = (data) => {
      console.log('SOCKET MESSAGES -> deletedMessages', data);
      this.removeMessages(data.msgIds);
    }

    for (const [evt, listener] of Object.entries(this.socketEventListeners)) {
      this.socketService.subscribe(evt, listener);
    }
  }

  removeMessages(msgIds) {
    if (msgIds && msgIds.length > 0) {
      msgIds.forEach((mId) => {
        const existingIdx = this.messageList.findIndex(m => m.id === mId);
        if (existingIdx >= 0) {
          this.messageList.splice(existingIdx, 1);
        }
      });
    }
  }

  msgTrackBy( i: number, el: any ) {
    return el ? el.id : null;
  }

  subscribeToScrollTop() {
    this.content.scrollEvents = true;

    this.content.ionScrollEnd.subscribe((data)=>{
      console.log('ionScrollEnd');
      this.content.getScrollElement().then(scrl=>{
        if (scrl.scrollTop < 10) {
          this.getPrevMessages();
        }
      });
    });
  }

  setEventHandlers() {
    this.platform.pause.subscribe(async () => {
      console.log('Pause event detected');
    });

    this.platform.resume.subscribe(async () => {
      console.log('Resume event detected');
    });
  }

  markAsRead(event) {
    console.log('MarkAsReadAttemt', event);
    clearTimeout(this.markAsReadTimeout);

    this.markAsReadTimeout = setTimeout(()=>{
      this.markChatAsRead();
    }, 3000);
  }

  timeWheelEvent(event) {
    clearTimeout(this.wheelEventTimeout);
    this.wheelEventTimeout = setTimeout(()=>{
      this.checkWheelEvent(event);
    }, 1000);
  }

  checkWheelEvent(event) {
    this.content.getScrollElement().then(scrl=>{
      if (event.deltaY < 0 && scrl.scrollTop < 10) {
        this.getPrevMessages();
      }
      else if (event.deltaY > 0 && (scrl.scrollTop + scrl.offsetHeight) === scrl.scrollHeight) {
        this.markChatAsRead();
      }

    });

  }

  markChatAsRead() {
    console.log('MarkAsReadCall');
    this.chatService.markChatRead(this.chatData.id).subscribe(result => {

    });    
  }

  async takePicture() {

    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri
    });

    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    //let imageUrl = image.webPath;

    console.log(image);

    // Can be set to the src of an image now
    //imageElement.src = imageUrl;
  };

  addAttachment(type) {
    if (type === 'document') {
      this.docFile.nativeElement.click();
    }
    else if (type === 'gallery') {
      this.galleryFile.nativeElement.click();
    }
    else if (type === 'campic') {
      this.camPicFile.nativeElement.click();
    }
    else if (type === 'camvideo') {
      this.camVideoFile.nativeElement.click();
    }
  }

  toggleAttachmentFabs() {
    console.log('FAB TOGGLED');
    if (this.attachmentFabsVisible === false) {
      this.attachmentFabsVisible = true;
    }
    else {
      this.attachmentFabsVisible = false;
    }
  }

  shareFiles(event) {

    for (const uf of event.target.files) {
      const newUpload = this.storageService.uploadFile(uf);

      newUpload.chatId = this.chatData.id;

      /*
      newUpload.senderId = this.userID;
      newUpload.chatData = {
        uid: this.chatData.uid,
        users: JSON.parse(JSON.stringify(this.chatData.users)),
        isGroup: this.chatData.isGroup
      };
      newUpload.senderUid = this.userID;

      /*if (this.chatData.isGroup) {
        newUpload.chatData
      }*/

      newUpload.percentage = newUpload.task.percentageChanges();
      newUpload.task.snapshotChanges().pipe(
        finalize(() => {
          newUpload.downloadUrl = newUpload.fileRef.getDownloadURL();
          newUpload.downloadUrl.subscribe(
            (next) => {
              if (next !== undefined && next !== '') {
                newUpload.finished = true;
                this.sendFileMessage(next, newUpload);
              }
            }
          );
        })
      )
      .subscribe();

      this.uploads.push(newUpload);

      setTimeout(()=>{
        this.checkScroll(null, 'shareFiles', 0);
      },500);
    }
  }

  sendFileMessage(downloadUrl, uploadedFile) {

    console.log('sendFileMessage', downloadUrl, uploadedFile);
    this.chatService.createMessage(uploadedFile.chatId, uploadedFile.fileType, downloadUrl).subscribe(result => {
      if (!result.error) {
        console.log('Message sent', result);
        this.clearNewMsg();
      }      
    });    
  }

  getDocName(url) {
    return unescape(url).split('/').pop().split('?').shift();
  }

  downloadFirebaseFile(url) {

    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = (event) => {
      const blob = xhr.response;
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = this.getDocName(url);
      downloadLink.click();
    };
    xhr.open('GET', url);
    xhr.send();

  }

  async openImageViewer(url) {
    const modal = await this.modalController.create({
      component: ViewerModalComponent,
      componentProps: {
        src: url
      },
      cssClass: 'ion-img-viewer',
      keyboardClose: true,
      showBackdrop: true
    });

    return await modal.present();
  }

  /****** AUDIO RECORDINGS *******/

  //Setup gestures for the audio button
  setupAudioGesture() {
    const moveGesture = this.gestureCtrl.create({
      el: this.audioFab.nativeElement,
      threshold: 0,
      gestureName: 'hold',
      onStart: ev => {
        this.startAudioRecording();
      },
      onMove: ev => {

        //when swiped left - audio gets canceled
        if (ev.deltaX < -150) {
          this.endAudioRecording(true);
        }
        else {
          const opacity = .5;
          const factor = (ev.deltaX < 0 ? ((ev.deltaX * -1) / 300) : 0);

          this.cancelSlider.nativeElement.style.transform = `translate(${ev.deltaX}px, 0)`;
          this.cancelSlider.nativeElement.style.opacity = `${(opacity+factor)}`;
        }
        /*const currentX = ev.currentX;
        const currentY = ev.currentY;

        this.box.nativeElement.style.transform = `translate(${currentX}px, ${currentY-headerHeight}px)`;*/
      },
      onEnd: ev => {
        this.endAudioRecording(false);
      }
    });

    // Don't forget to enable!
    moveGesture.enable(true);
  }

  startAudioRecording(){
    console.log('startAudioRecording');

    if (this.platform.is('ios')) {
      this.audioRecording.file.name = Math.floor((Math.random() * 1000000000)) + '_audiofile.m4a';
      this.audioRecording.file.path = this.nativeFile.tempDirectory;
      this.audioRecording.file.pathAbs = this.audioRecording.file.path.replace(/^file:\/\//, '');
    }
    else {
      this.audioRecording.file.name = Math.floor((Math.random() * 1000000000)) + '_audiofile.aac';
      this.audioRecording.file.path = this.nativeFile.cacheDirectory;
      this.audioRecording.file.pathAbs = this.audioRecording.file.path;
    }

    this.nativeFile.createFile(
      this.audioRecording.file.path, this.audioRecording.file.name, true).then((file) => {

        this.audioRecording.started = true;
        this.audioRecordBox.nativeElement.style.display = 'flex';
        this.audioFab.nativeElement.classList.add('recording');
        this.startRecordingTimer();

        this.audioRecording.file.entry = file;

        this.audioRecording.file.media = this.media.create(this.audioRecording.file.pathAbs
          + this.audioRecording.file.name);

        this.audioRecording.file.media.onSuccess.subscribe((data) => {
          console.log('Action is successful', data);
          console.log('currentFile', this.audioRecording.file);

          if(!this.audioRecording.wasCanceled) {
            this.shareAudioFile();
          }
        });

        this.audioRecording.file.media.onError.subscribe(error => {
          console.log('Error!', error);
          this.alertController.create({
            header: ':(',
            message: 'Al parecer, has negado el uso del micrófono. Puedes otorgar el permiso, en los ajustes del sistema.',
            buttons: ['OK'],
          }).then(alert => {
            alert.present();
          });
          this.audioRecording.wasCanceled = true;
          this.audioRecording.file.media.release();
        });

        this.audioRecording.file.media.startRecord();

      //setTimeout(() => this.audioRecording.currentFile.stopRecord(), 10000);
    });

    /*navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        console.log('ios',this.platform.is('ios'));

        const options = {
          mimeType: (this.platform.is('ios') ? 'audio/mp4' : 'audio/webm')
        };

        this.audioRecording.recorder = new MediaRecorder(stream, options);
        this.audioRecording.recorder.start();

        console.log( this.audioRecording.recorder.mimeType);
        const audioChunks = [];

        this.audioRecording.recorder.addEventListener('dataavailable', event => {
          audioChunks.push(event.data);
        });

        this.audioRecording.recorder.addEventListener('stop', () => {

          if(!this.audioRecording.wasCanceled) {
            const audioBlob = new Blob(audioChunks, {
              type: (this.platform.is('ios') ? 'audio/mp4' : 'audio/webm')
            });

            //const audioUrl = URL.createObjectURL(audioBlob);

            this.shareAudioFile(audioBlob);

            //this.chatService.sendAudioMessage(audioUrl, this.chatData, this.isAgentSession);
          }
        });
      });*/
  }

  endAudioRecording(wasCanceled) {
    console.log('endAudioRecording');
    this.audioRecording.started = false;
    this.audioRecording.wasCanceled = wasCanceled;
    this.audioRecordBox.nativeElement.style.display = 'none';
    this.cancelSlider.nativeElement.style.transform = `translate(0, 0)`;
    this.cancelSlider.nativeElement.style.opacity = `.5`;
    this.audioFab.nativeElement.classList.remove('recording');
    this.stopRecordingTimer();

    if(this.audioRecording.file.media){
      this.audioRecording.file.media.stopRecord();
    }

    /*if(this.audioRecording.recorder.state !== 'inactive'){
      this.audioRecording.recorder.stream.getTracks().forEach((track) => {
        console.log('track to stop', track);
        if (track.readyState === 'live') {
            track.stop();
        }
      });
      this.audioRecording.recorder.stop();
    }*/

  }

  startRecordingTimer() {
    this.audioTimer.nativeElement.innerHTML = '00:00';

    this.audioRecording.timer.interval = setInterval(() => {

      this.audioRecording.timer.seconds++;

      const minutes = Math.floor(this.audioRecording.timer.seconds / 60);
      const seconds = Math.floor(this.audioRecording.timer.seconds % 60);

      this.audioTimer.nativeElement.innerHTML =
        (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
    }, 1000);
  }

  stopRecordingTimer() {
    clearInterval(this.audioRecording.timer.interval);

    this.audioRecording.timer = {
      parsed: '00:00',
      seconds: 0,
      interval: null
    };
  }

  shareAudioFile() {

    this.storageService.uploadAudioFile(this.audioRecording.file, (res) => {
      const newUpload = res;
      newUpload.chatId = this.chatData.id;
      /*newUpload.chatData = {
        uid: this.chatData.uid,
        users: JSON.parse(JSON.stringify(this.chatData.users)),
        isGroup: this.chatData.isGroup
      };
      newUpload.senderUid = this.userID;*/

      newUpload.percentage = newUpload.task.percentageChanges();
      newUpload.task.snapshotChanges().pipe(
        finalize(() => {
          newUpload.downloadUrl = newUpload.fileRef.getDownloadURL();
          newUpload.downloadUrl.subscribe(
            (next) => {
              if (next !== undefined && next !== '') {
                newUpload.finished = true;
                this.sendFileMessage(next, newUpload);
              }
            }
          );
        })
      )
      .subscribe();

      this.uploads.push(newUpload);

      setTimeout(()=>{
        this.content.scrollToBottom(300);
      },500);

    });

  }

  replaceAudioFile(url) {
    return url.replace('_audiofile','_audiofile_output.flac');
  }

  logEvent(event){
    console.log(event);
  }

  /****** MESSAGE SELECTION / DELETE *******/
  initLongPress(ev, message) {
    this.longPressTimer = false;
    console.log('INICIA PRESION');
    if (message.sender_id === this.userID && this.selectedMessages.length === 0) {
      console.log('SETEA TIMEOUT');
      this.selectionTimer = setTimeout(()=>{
        console.log('EJECUTA TIMEOUT LONGPRESS', message);
        this.selectMsg(message);
        this.longPressTimer = true;

      }, 1000);
    }
  }

  endLongPress(ev, message) {
    clearTimeout(this.selectionTimer);
    if (!this.longPressTimer) {
      this.clickMsg(ev, message);
    }
  }

  clickMsg(ev, message) {
    console.log('CLICK MSG', ev, message);
    //&& (ev == null || this.selectedMessages.length > 0)
    if (message.sender_id === this.userID && message.type !== 'system' && this.selectedMessages && this.selectedMessages.length > 0) {
      this.selectMsg(message);
    }
  }

  selectMsg(message) {
    console.log('SELMSG', message);
    if(message.sender_id === this.userID && message.type !== 'system') {

      const idx = this.selectedMessages.indexOf(message.id);
      if (idx > -1) {
        this.selectedMessages.splice(idx, 1);
      }
      else{
        this.selectedMessages.push(message.id);
      }
    }

    console.log(this.selectedMessages);
  }

  clearSelectedMsg() {
    this.selectedMessages = [];
  }

  deleteSelectedMsg() {
    this.isDeletingMessages = true;
    this.chatService.deleteChatMessages(this.chatData.id, this.selectedMessages).subscribe((res)=>{
      if(!res.error) {
        const amountDeleted = this.selectedMessages.length;
         
        this.toastController.create({
          message: amountDeleted + (amountDeleted > 1 ? ' mensajes eliminados!' : ' mensaje eliminado!'),
          duration: 3000,
          position: 'bottom'
        }).then((toast) => {
          toast.present();
        });
      }

      this.clearSelectedMsg();
      this.isDeletingMessages = false;
    });
  }

  async showChatInfo(ev: any) {
    const popover = await this.popoverController.create({
      component: BtnsPopoverComponent,
      componentProps: {
        isAdminSession: this.userService.currentUser.is_admin,
        chatData: this.chatData,
        groupEditAction: () => {
          this.msgAction.emit('editGroup');
        }
      },
      cssClass: 'desk-chat-info-pop',
      event: ev,
      translucent: true
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  requestPhoneCall(ev) {
    this.alertController.create({
      header: 'Solicitar llamado',
      message: 'Ingresa tu número de teléfono',
      inputs: [{
        name: 'uphone',
        type: 'text',
        placeholder: 'Número de teléfono',
        value: (this.userService.currentUser.phone ? this.userService.currentUser.phone : '')
      }],
      buttons: [{
        text: 'CANCELAR',
        role: 'cancel',
        cssClass: 'secondary',
      },{
        text: 'SOLICITAR',
        handler: (values) => {
          if (!values.uphone || values.uphone.length < 7) {
            this.toastController.create({
              message: 'Ingresar un número de 7 o más cifras',
              duration: 3000,
              position: 'bottom'
            }).then((toast) => {
              toast.present();
            });
            return false;
          }
          this.confirmPhoneCallRequest(values.uphone);
        }
      }]
    }).then(alert => {
      alert.present();
    });
  }

  confirmPhoneCallRequest(userPhone) {
    console.log('confirmPhoneCallRequest', userPhone);

    this.userService.updateCurrentUser({phone: userPhone});
    this.chatService.createMessage(this.chatData.id, 'system', 'SOLICITUD DE LLAMADA TELEFÓNICA').subscribe(result => {
      if (!result.error) {
        console.log('Message sent - call request', result);
      }      
    }); 
  }

  closeCurrentChat() {
    //console.log(this.route.toString());
    this.msgAction.emit('closeChat');
  }
}
